import type { ColumnDef } from "@tanstack/react-table"

import {
  GoodsReceiptPalletActionsCell,
  GoodsReceiptPalletBatchNumbersCell,
  GoodsReceiptPalletDestinationCell,
  GoodsReceiptPalletLotNumbersCell,
  GoodsReceiptPalletProductQtyCell,
  GoodsReceiptPalletReferenceIdCell,
} from "../../../../../components"

import type { GoodsReceiptPallet } from "@/graphql/codegen/graphql"

interface UseStoredGoodsReceiptBuildPalletsColumnsParams {
  isAkrochemManaged?: boolean
  onQrPrint?: (pallet: GoodsReceiptPallet) => void
}

export const useStoredGoodsReceiptBuildPalletsColumns = ({
  isAkrochemManaged = true,
  onQrPrint,
}: UseStoredGoodsReceiptBuildPalletsColumnsParams): ColumnDef<GoodsReceiptPallet>[] => {
  return [
    {
      accessorKey: "palletQty",
      header: "Product / Qty",
      cell: ({ row }) => <GoodsReceiptPalletProductQtyCell pallet={row.original} />,
    },
    {
      accessorKey: "lots",
      header: "Lot #",
      enableSorting: false,
      cell: ({ row }) => {
        const uomId = row.original.goodsReceiptPalletRow?.product?.packageUsWeightUom
        const palletRow = row.original.goodsReceiptPalletRow!
        return <GoodsReceiptPalletLotNumbersCell uomId={uomId} goodsReceiptPalletRow={palletRow} />
      },
    },
    {
      accessorKey: "batchNumber",
      header: "Batch #",
      enableSorting: false,
      cell: ({ row }) => (
        <GoodsReceiptPalletBatchNumbersCell goodsReceiptPalletRow={row.original.goodsReceiptPalletRow!} />
      ),
    },
    {
      accessorKey: "currentLocation",
      header: "Current Location",
      enableSorting: false,
      cell: ({ row }) => <GoodsReceiptPalletDestinationCell pallet={row.original} shouldShowEdit={false} />,
    },
    {
      accessorKey: "referenceId",
      header: "Reference ID",
      cell: ({ row }) => <GoodsReceiptPalletReferenceIdCell pallet={row.original} />,
    },
    {
      accessorKey: "actions",
      header: "",
      enableSorting: false,
      size: 68,
      cell: ({ row }) => (
        <GoodsReceiptPalletActionsCell
          pallet={row.original}
          shouldShowQrPrint={isAkrochemManaged}
          shouldShowDelete={false}
          onQrPrint={() => onQrPrint?.(row.original)}
        />
      ),
    },
  ]
}
